(() => {
  const dialog = document.querySelector('[data-mailchimp-dialog]');
  const formRoots = Array.from(document.querySelectorAll('[data-mailchimp-form-root]'));
  const dialogRoot = dialog ? dialog.querySelector('[data-mailchimp-form-root]') : null;

  if (!dialog && !formRoots.length) return;

  if (window.jQuery && !window.__mailchimpSignupValidationInitialized) {
    window.fnames = new Array();
    window.ftypes = new Array();
    fnames[1] = 'FNAME';
    ftypes[1] = 'text';
    fnames[2] = 'LNAME';
    ftypes[2] = 'text';
    fnames[0] = 'EMAIL';
    ftypes[0] = 'email';
    fnames[6] = 'SMSPHONE';
    ftypes[6] = 'smsphone';
    fnames[4] = 'PHONE';
    ftypes[4] = 'phone';
    fnames[3] = 'ADDRESS';
    ftypes[3] = 'address';
    fnames[5] = 'BIRTHDAY';
    ftypes[5] = 'birthday';
    window.$mcj = window.jQuery.noConflict(true);
    window.__mailchimpSignupValidationInitialized = true;
  }

  const closeButton = dialog ? dialog.querySelector('[data-mailchimp-dialog-close]') : null;
  const entryEmailFields = Array.from(document.querySelectorAll('[data-mailchimp-entry-email]'));
  const dialogTriggers = Array.from(document.querySelectorAll('[data-mailchimp-dialog-trigger]'));
  let opener = null;
  let tooltipTarget = null;
  let validationTooltip = document.querySelector('.mailchimp-validation-tooltip');

  const getFormParts = (root) => ({
    root,
    completeForm:
      root.querySelector('[data-mailchimp-complete-form]') ||
      document.getElementById(root.dataset.mailchimpCompleteFormId || ''),
    emailField: root.querySelector('[data-mailchimp-form-email]'),
    smsCountryField: root.querySelector('[data-mailchimp-sms-country]'),
    smsLocalField: root.querySelector('[data-mailchimp-sms-local]'),
    smsHiddenField: root.querySelector('[data-mailchimp-sms-hidden]'),
    errorResponse: root.querySelector('[data-mailchimp-error-response]'),
    successResponse: root.querySelector('[data-mailchimp-success-response]'),
    customSuccess: root.querySelector('[data-mailchimp-custom-success]'),
    submitButton: root.querySelector('input[type="submit"], button[type="submit"]'),
    successBehavior: root.dataset.mailchimpSuccessBehavior || 'stay',
    successRedirectUrl: root.dataset.mailchimpSuccessRedirectUrl || '',
    successQueryParameter: root.dataset.mailchimpSuccessQueryParameter || 'signed-up=1',
    successMessage: root.dataset.mailchimpSuccessMessage || '',
    hideFormAfterSuccess: root.dataset.mailchimpHideFormAfterSuccess === 'true',
    showSubmitLoadingState: root.dataset.mailchimpShowSubmitLoadingState === 'true',
    countrySelectedFlags: Array.from(root.querySelectorAll('[data-mailchimp-country-selected-flag]')),
    countrySelectedCodes: Array.from(root.querySelectorAll('[data-mailchimp-country-selected-code]')),
  });

  const getInteractiveFields = (parts) =>
    Array.from(parts?.root?.querySelectorAll('input, select, textarea') || []).filter(
      (field) =>
        field instanceof HTMLInputElement ||
        field instanceof HTMLSelectElement ||
        field instanceof HTMLTextAreaElement
    );

  const formPartsList = formRoots.map(getFormParts);
  const dialogFormParts = dialogRoot ? getFormParts(dialogRoot) : null;

  if (!validationTooltip) {
    validationTooltip = document.createElement('div');
    validationTooltip.className = 'mailchimp-validation-tooltip';
    validationTooltip.setAttribute('aria-live', 'polite');
    document.body.appendChild(validationTooltip);
  }

  const setEntryMessage = (form, message) => {
    const messageElement = form.querySelector('[data-mailchimp-entry-message]');

    if (!messageElement) return;

    if (message) {
      messageElement.textContent = message;
      messageElement.hidden = false;
      return;
    }

    messageElement.textContent = '';
    messageElement.hidden = true;
  };

  const handleEntrySubmission = (entryForm) => {
    if (!(entryForm instanceof HTMLElement)) return;

    const entryEmailField = entryForm.querySelector('[data-mailchimp-entry-email]');

    if (!(entryEmailField instanceof HTMLInputElement)) return;

    setEntryMessage(entryForm, '');

    const submittedEmail = entryEmailField.value.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(submittedEmail);

    if (!submittedEmail || !isValidEmail) {
      showValidationTooltip(
        entryEmailField,
        submittedEmail ? 'Please enter a valid email address.' : 'Please enter your email address.'
      );
      return;
    }

    hideValidationTooltip();
    openDialog(entryForm, submittedEmail);
  };

  const openDialog = (entryForm = null, submittedEmail = '') => {
    if (!dialog || !dialogFormParts) return;

    opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;

    if (entryForm) {
      setEntryMessage(entryForm, '');
    }

    if (dialogFormParts.emailField instanceof HTMLInputElement) {
      dialogFormParts.emailField.value = submittedEmail;
    }

    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }

    window.requestAnimationFrame(() => {
      const firstRequiredEmptyField = dialogFormParts.completeForm
        ? Array.from(dialogFormParts.completeForm.querySelectorAll('input[required], select[required], textarea[required]')).find(
            (field) => field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement
              ? field.value.trim() === ''
              : false
          )
        : null;
      const nextField = firstRequiredEmptyField || dialogFormParts.emailField || closeButton;

      if (nextField instanceof HTMLElement) {
        nextField.focus();
      }
    });
  };

  const closeDialog = () => {
    if (!dialog) return;

    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
      return;
    }

    dialog.removeAttribute('open');

    if (opener && typeof opener.focus === 'function') {
      opener.focus();
    }
  };

  const setMailchimpError = (parts, message) => {
    if (!parts?.errorResponse) return;

    if (message) {
      parts.errorResponse.innerHTML = message;
      parts.errorResponse.style.display = 'block';
      return;
    }

    parts.errorResponse.innerHTML = '';
    parts.errorResponse.style.display = 'none';
  };

  const setMailchimpSuccess = (parts, message) => {
    if (!parts?.successResponse) return;

    if (message) {
      parts.successResponse.innerHTML = message;
      parts.successResponse.style.display = 'block';
      return;
    }

    parts.successResponse.innerHTML = '';
    parts.successResponse.style.display = 'none';
  };

  const setSubmittingState = (parts, isSubmitting) => {
    if (!parts?.root) return;

    if (parts.submitButton instanceof HTMLInputElement || parts.submitButton instanceof HTMLButtonElement) {
      parts.submitButton.disabled = isSubmitting;
    }

    if (!parts.showSubmitLoadingState) return;

    parts.root.classList.toggle('is-submitting', isSubmitting);

    if (isSubmitting) {
      parts.root.setAttribute('aria-busy', 'true');
      return;
    }

    parts.root.removeAttribute('aria-busy');
  };

  const showCompletedState = (parts) => {
    if (!parts?.root || !parts.hideFormAfterSuccess) return;

    setSubmittingState(parts, false);
    setMailchimpError(parts, '');

    if (parts.customSuccess instanceof HTMLElement) {
      setMailchimpSuccess(parts, '');
      parts.customSuccess.hidden = false;
    } else {
      setMailchimpSuccess(parts, parts.successMessage || 'Thank you for submitting.');
    }

    parts.root.classList.add('is-success');
  };

  const hideValidationTooltip = () => {
    if (tooltipTarget instanceof HTMLElement) {
      tooltipTarget.classList.remove('mailchimp-input--invalid');
      tooltipTarget.removeAttribute('aria-invalid');
    }

    tooltipTarget = null;
    validationTooltip.textContent = '';
    validationTooltip.classList.remove('is-visible');
    validationTooltip.style.top = '';
    validationTooltip.style.left = '';
  };

  const showValidationTooltip = (target, message) => {
    if (!(target instanceof HTMLElement) || !message) return;

    hideValidationTooltip();

    tooltipTarget = target;
    tooltipTarget.classList.add('mailchimp-input--invalid');
    tooltipTarget.setAttribute('aria-invalid', 'true');
    validationTooltip.textContent = message;
    validationTooltip.classList.add('is-visible');
    validationTooltip.style.visibility = 'hidden';

    const targetRect = target.getBoundingClientRect();
    const tooltipRect = validationTooltip.getBoundingClientRect();
    const horizontalPadding = 12;
    const left = Math.min(
      Math.max(horizontalPadding, targetRect.left),
      window.innerWidth - tooltipRect.width - horizontalPadding
    );
    const showAbove = targetRect.bottom + 12 + tooltipRect.height > window.innerHeight;
    const top = showAbove
      ? Math.max(horizontalPadding, targetRect.top - tooltipRect.height - 10)
      : Math.min(window.innerHeight - tooltipRect.height - horizontalPadding, targetRect.bottom + 10);

    validationTooltip.style.left = `${left}px`;
    validationTooltip.style.top = `${top}px`;
    validationTooltip.style.visibility = 'visible';
  };

  const buildSmsValue = (parts) => {
    if (
      !(parts?.smsCountryField instanceof HTMLSelectElement) ||
      !(parts?.smsLocalField instanceof HTMLInputElement) ||
      !(parts?.smsHiddenField instanceof HTMLInputElement)
    ) {
      return true;
    }

    const countryCode = parts.smsCountryField.value.trim();
    const localDigits = parts.smsLocalField.value.replace(/\D/g, '');
    const combinedDigits = `${countryCode.replace(/\D/g, '')}${localDigits}`;

    parts.smsLocalField.setCustomValidity('');
    setMailchimpError(parts, '');

    if (!localDigits) {
      parts.smsHiddenField.value = '';
      return true;
    }

    if (combinedDigits.length < 8 || combinedDigits.length > 15) {
      parts.smsHiddenField.value = '';
      parts.smsLocalField.setCustomValidity('Please enter a valid phone number.');
      return false;
    }

    parts.smsHiddenField.value = `${countryCode}${localDigits}`;
    parts.smsLocalField.value = localDigits;
    return true;
  };

  const syncCountryDisplay = (parts) => {
    if (!(parts?.smsCountryField instanceof HTMLSelectElement)) {
      return;
    }

    const selectedOption = parts.smsCountryField.options[parts.smsCountryField.selectedIndex];
    const countryCode = selectedOption?.value || '+1';
    const countryFlag = selectedOption?.dataset.countryFlag || '🇺🇸';

    parts.countrySelectedFlags.forEach((element) => {
      element.textContent = countryFlag;
    });

    parts.countrySelectedCodes.forEach((element) => {
      element.textContent = countryCode;
    });

    buildSmsValue(parts);
  };

  const getFieldValidationMessage = (field) => {
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) {
      return 'Please complete this field.';
    }

    if (field.validity.valueMissing) {
      if (field.type === 'email') return 'Please enter your email address.';
      return 'Please complete this field.';
    }

    if (field.validity.typeMismatch && field.type === 'email') {
      return 'Please enter a valid email address.';
    }

    return field.validationMessage || 'Please complete this field.';
  };

  const validateCompleteForm = (parts) => {
    if (!parts?.completeForm) return true;

    const fields = getInteractiveFields(parts);

    const nonSmsFields = fields.filter((field) => field !== parts.smsLocalField && field.type !== 'hidden');

    const invalidField = nonSmsFields.find((field) => !field.checkValidity());

    if (invalidField) {
      const message = getFieldValidationMessage(invalidField);
      setMailchimpError(parts, message);
      showValidationTooltip(invalidField, message);
      invalidField.focus();
      return false;
    }

    const isSmsValid = buildSmsValue(parts);

    if (!isSmsValid && parts.smsLocalField instanceof HTMLInputElement) {
      const message = parts.smsLocalField.validationMessage;
      setMailchimpError(parts, message);
      showValidationTooltip(parts.smsLocalField, message);
      parts.smsLocalField.focus();
      return false;
    }

    hideValidationTooltip();
    setMailchimpError(parts, '');
    setMailchimpSuccess(parts, '');
    return true;
  };

  const getMailchimpAjaxUrl = (form) => {
    if (!(form instanceof HTMLFormElement)) return '';

    const action = form.getAttribute('action') || '';

    if (!action) return '';

    return action.replace('/post?u=', '/post-json?u=');
  };

  const parseMailchimpResponseMessage = (response) => {
    if (!response || typeof response.msg !== 'string') {
      return 'Something went wrong. Please try again.';
    }

    const parts = response.msg.split(' - ', 2);

    if (parts.length === 2 && /^[0-9]+$/.test(parts[0])) {
      return parts[1];
    }

    return response.msg;
  };

  const getSafeNavigationUrl = (value) => {
    if (typeof value !== 'string' || !value.trim()) return null;

    try {
      const url = new URL(value.trim(), window.location.href);

      if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;

      return url;
    } catch (error) {
      return null;
    }
  };

  const getSuccessQueryUrl = (queryValue) => {
    const url = new URL(window.location.href);
    const normalizedQuery = typeof queryValue === 'string' ? queryValue.trim().replace(/^\?/, '') : '';
    const queryParameters = new URLSearchParams(normalizedQuery || 'signed-up=1');

    queryParameters.forEach((value, key) => {
      if (key) url.searchParams.set(key, value);
    });

    return url;
  };

  const hasSuccessQuery = (queryValue) => {
    const normalizedQuery = typeof queryValue === 'string' ? queryValue.trim().replace(/^\?/, '') : '';
    const expectedParameters = new URLSearchParams(normalizedQuery || 'signed-up=1');
    const currentParameters = new URL(window.location.href).searchParams;
    let expectedParameterCount = 0;
    let matches = true;

    expectedParameters.forEach((value, key) => {
      if (!key) return;

      expectedParameterCount += 1;
      if (!currentParameters.getAll(key).includes(value)) {
        matches = false;
      }
    });

    return expectedParameterCount > 0 && matches;
  };

  const applySuccessBehavior = (parts) => {
    if (parts?.successBehavior === 'redirect') {
      const redirectUrl = getSafeNavigationUrl(parts.successRedirectUrl);

      if (redirectUrl) {
        window.location.assign(redirectUrl.href);
        return true;
      }
    }

    if (parts?.successBehavior === 'query') {
      const successUrl = getSuccessQueryUrl(parts.successQueryParameter);
      window.location.assign(successUrl.href);
      return true;
    }

    return false;
  };

  const submitNonDialogMailchimpForm = (parts) => {
    if (!parts?.completeForm || parts.completeForm.id === 'mc-embedded-subscribe-form') {
      return;
    }

    const ajaxUrlBase = getMailchimpAjaxUrl(parts.completeForm);

    if (!ajaxUrlBase) {
      setMailchimpError(parts, 'Unable to submit the signup form right now.');
      return;
    }

    const callbackName = `mailchimpJsonpCallback_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    const callbackParam = `c=${callbackName}`;
    const params = new URLSearchParams();
    const formData = new FormData(parts.completeForm);

    for (const [key, value] of formData.entries()) {
      params.append(key, typeof value === 'string' ? value : '');
    }

    const script = document.createElement('script');
    const separator = ajaxUrlBase.includes('?') ? '&' : '?';
    let settled = false;
    let timeoutId = null;

    const cleanup = () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }

      delete window[callbackName];
      window.clearTimeout(timeoutId);
      setSubmittingState(parts, false);
    };

    const handleResponse = (response) => {
      if (settled) return;
      settled = true;

      cleanup();
      setMailchimpError(parts, '');

      if (response?.result === 'success') {
        setMailchimpSuccess(parts, parts.successMessage || response.msg);
        parts.completeForm.reset();
        syncCountryDisplay(parts);
        hideValidationTooltip();
        const navigated = applySuccessBehavior(parts);
        if (!navigated) showCompletedState(parts);
        return;
      }

      setMailchimpSuccess(parts, '');
      setMailchimpError(parts, parseMailchimpResponseMessage(response));
    };

    window[callbackName] = handleResponse;

    script.onerror = () => {
      if (settled) return;
      settled = true;
      cleanup();
      setMailchimpSuccess(parts, '');
      setMailchimpError(parts, 'Unable to submit the signup form right now.');
    };

    setSubmittingState(parts, true);
    setMailchimpSuccess(parts, '');
    script.src = `${ajaxUrlBase}${separator}${params.toString()}&${callbackParam}`;
    document.body.appendChild(script);

    timeoutId = window.setTimeout(() => {
      if (settled) return;

      settled = true;
      cleanup();
      setMailchimpSuccess(parts, '');
      setMailchimpError(parts, 'The signup is taking too long. Please try again.');
    }, 15000);
  };

  document.addEventListener('submit', (event) => {
    const entryForm = event.target.closest('[data-mailchimp-entry-form]');

    if (!entryForm) return;

    event.preventDefault();
    handleEntrySubmission(entryForm);
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const submitTrigger = event.target.closest('[data-mailchimp-entry-submit]');

    if (!(submitTrigger instanceof HTMLElement)) return;

    const entryForm = submitTrigger.closest('[data-mailchimp-entry-form]');

    if (!(entryForm instanceof HTMLElement) || entryForm instanceof HTMLFormElement) return;

    event.preventDefault();
    handleEntrySubmission(entryForm);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;

    if (!(event.target instanceof Element)) return;

    const entryEmailField = event.target.closest('[data-mailchimp-entry-email]');

    if (!(entryEmailField instanceof HTMLInputElement)) return;

    const entryForm = entryEmailField.closest('[data-mailchimp-entry-form]');

    if (!(entryForm instanceof HTMLElement) || entryForm instanceof HTMLFormElement) return;

    event.preventDefault();
    handleEntrySubmission(entryForm);
  });

  entryEmailFields.forEach((field) => {
    if (!(field instanceof HTMLInputElement)) return;

    field.addEventListener('input', hideValidationTooltip);
    field.addEventListener('blur', () => {
      if (field.value.trim() !== '') {
        hideValidationTooltip();
      }
    });
  });

  dialogTriggers.forEach((trigger) => {
    if (!(trigger instanceof HTMLElement)) return;

    trigger.addEventListener('click', () => {
      hideValidationTooltip();
      openDialog(null, '');
    });
  });

  formPartsList.forEach((parts) => {
    if (
      parts.successBehavior === 'query' &&
      parts.hideFormAfterSuccess &&
      hasSuccessQuery(parts.successQueryParameter)
    ) {
      showCompletedState(parts);
    }

    if (parts.smsLocalField instanceof HTMLInputElement) {
      parts.smsLocalField.addEventListener('input', () => {
        parts.smsLocalField.setCustomValidity('');
        setMailchimpError(parts, '');
        hideValidationTooltip();
      });

      parts.smsLocalField.addEventListener('blur', () => {
        if (parts.smsLocalField.value.trim() !== '') {
          buildSmsValue(parts);
          hideValidationTooltip();
        }
      });
    }

    if (parts.smsCountryField instanceof HTMLSelectElement) {
      syncCountryDisplay(parts);
      parts.smsCountryField.addEventListener('change', () => {
        syncCountryDisplay(parts);
        hideValidationTooltip();
      });
    }

    if (parts.completeForm) {
      const interactiveFields = getInteractiveFields(parts);

      interactiveFields.forEach((field) => {
        field.addEventListener('input', () => {
          if (field === tooltipTarget || field === parts.smsLocalField) {
            hideValidationTooltip();
          }
          setMailchimpError(parts, '');
          setMailchimpSuccess(parts, '');
        });

        field.addEventListener('blur', () => {
          if (field.value.trim() !== '') {
            hideValidationTooltip();
          }
        });
      });

      parts.completeForm.addEventListener(
        'submit',
        (event) => {
          if (!validateCompleteForm(parts)) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }

          if (parts.completeForm.id !== 'mc-embedded-subscribe-form') {
            event.preventDefault();
            event.stopImmediatePropagation();
            submitNonDialogMailchimpForm(parts);
          }
        },
        true
      );
    }
  });

  if (closeButton) {
    closeButton.addEventListener('click', closeDialog);
  }

  if (dialog) {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeDialog();
      }
    });

    dialog.addEventListener('close', () => {
      hideValidationTooltip();
      if (opener && typeof opener.focus === 'function') {
        opener.focus();
      }
    });
  }

  window.addEventListener('resize', hideValidationTooltip);
  window.addEventListener('scroll', hideValidationTooltip, true);
})();
